module.exports = __webpack_public_path__ + "images/search_icon-b6110db34e5a7fb75e56d1770de7ec6b.svg";


//////////////////
// WEBPACK FOOTER
// ./app/frontend/images/search_icon.svg
// module id = 234
// module chunks = 0